export default function Contact() {
  return (
    <section id="contact" className="relative py-24 md:py-32 px-4 md:px-8 bg-background-950">
      <div className="max-w-4xl mx-auto text-center">
        <div className="relative rounded-3xl overflow-hidden aspect-[21/9] mb-12 bg-background-800/50">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20anonymous%20tip%20and%20whistleblower%20theme%20on%20dark%20background%20with%20neon%20green%20accents%2C%20envelope%20and%20message%20motif%2C%20mysterious%20and%20secure%20communication%20aesthetic%2C%20minimal%20composition%2C%20dark%20atmosphere&width=1400&height=600&seq=contact-submit-visual&orientation=landscape"
            alt="匿名投稿"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-background-950/30"></div>
        </div>

        <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-background-800/80 text-background-400 text-xs font-semibold rounded-full border border-background-700/60 whitespace-nowrap mb-6">
          <i className="ri-mail-send-line text-[10px]"></i>
          线索投稿
        </span>

        <p className="text-3xl md:text-5xl font-extrabold text-background-950 leading-tight mb-4">
          你有猛料？<span className="font-heading italic text-accent-600">我们来爆</span>
        </p>

        <p className="text-sm text-background-600 max-w-lg mx-auto leading-relaxed">
          51爆料网欢迎每一位知情人士提供爆料线索。我们承诺严格保护投稿人隐私，所有信息均经过匿名化处理。你的每一次爆料，都是在为真相发声。
        </p>

        <a
          href="#contact"
          className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 bg-background-950 text-background-50 font-semibold text-sm rounded-full hover:bg-background-900 transition-all cursor-pointer whitespace-nowrap"
        >
          立即投稿
          <i className="ri-arrow-right-up-line text-base"></i>
        </a>
      </div>
    </section>
  );
}